import * as React from "react";
import cn from "classnames";

import styles = require("./style.less");

export class DataTableHeaderColumn extends React.Component<any, any> {
    render() {
        const {
            className,
            ...otherProps
        } = this.props;
        return (
            <th className={cn(className, styles.dataTableHeaderColumn)} {...otherProps}>
                {this.props.children}
            </th>
        );
    }
}